"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridTrendSLTPSettingAPI = exports.reducePositionCheckAPI = exports.useReducePositionCheckInfo = void 0;
const react_1 = require("react");
const lodash_1 = require("lodash");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const apis_1 = require("./apis");
Object.defineProperty(exports, "gridTrendSLTPSettingAPI", { enumerable: true, get: function () { return apis_1.gridTrendSLTPSettingAPI; } });
const trade_utils_lib_1 = require("trade_utils_lib");
const parseParamsToRequest = (_params) => {
    if (!_params.open_price || !Number(_params.open_price)) {
        throw { code: -1, message: "no open price" };
    }
    const req = Object.assign(Object.assign({}, _params), { open_price: _params.open_price, reduce_num: _params.reduce_num || 0 });
    return req;
};
const queryAPI = (request, orderType) => {
    return (0, apis_1.reducePositionCheckAPI)(request, orderType);
};
exports.reducePositionCheckAPI = queryAPI;
const useReducePositionCheckInfo = (params, orderType, reduce_num_percent) => {
    const [checkInfo, setCheckInfo] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const { open_price, reduce_num, orderId } = params;
    const depsExPrice = [reduce_num, orderId];
    const requestRef = (0, react_1.useRef)(params);
    requestRef.current = params;
    const debounceFn = (0, react_1.useRef)((0, lodash_1.debounce)(() => {
        const sub = (0, rxjs_1.of)(requestRef.current)
            .pipe((0, operators_1.map)((reqOp) => {
            return parseParamsToRequest(reqOp);
        }), (0, operators_1.mergeMap)((req) => {
            setLoading(true);
            return queryAPI(req, orderType).pipe((0, operators_1.catchError)((error) => {
                console.log(error);
                const newReq = Object.assign(Object.assign({}, req), { reduce_num: 0 });
                return queryAPI(newReq, orderType);
            }));
        }))
            .subscribe({
            next: (data) => {
                setCheckInfo(data);
                setLoading(false);
            },
            error: (error) => {
                setLoading(false);
                console.log(`useReducePositionCheckInfo debounce: ${JSON.stringify(error)}`);
            },
        });
        return sub;
    }, 500));
    // 用户输入防抖
    (0, react_1.useEffect)(() => {
        var _a;
        // 当输入参数小于1时不调用接口
        if (new trade_utils_lib_1.SafeDecimal(reduce_num_percent).lt(1)) {
            return;
        }
        const sub = (_a = debounceFn.current) === null || _a === void 0 ? void 0 : _a.call(debounceFn);
        return () => sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, depsExPrice);
    const throttleDepensOnPriceFn = (0, react_1.useRef)((0, lodash_1.throttle)(() => {
        const request = parseParamsToRequest(requestRef.current);
        const sub = queryAPI(request, orderType)
            .pipe((0, operators_1.catchError)((error) => {
            const newReq = Object.assign(Object.assign({}, request), { reduce_num: 0 });
            return queryAPI(newReq, orderType);
        }))
            .subscribe({
            next: (data) => {
                setCheckInfo(data);
            },
            error: (error) => {
                console.log(`useReducePositionCheckInfo throttle: ${JSON.stringify(error)}`);
            },
        });
        return sub;
    }, 5000));
    // 当前价格变更节流
    (0, react_1.useEffect)(() => {
        var _a;
        // 当输入参数小于1时不调用接口
        if (new trade_utils_lib_1.SafeDecimal(reduce_num_percent).lt(1)) {
            return;
        }
        // 只有在当前参数触发了check接口后才开启按价格轮训
        if (!checkInfo) {
            return;
        }
        const sub = (_a = throttleDepensOnPriceFn.current) === null || _a === void 0 ? void 0 : _a.call(throttleDepensOnPriceFn);
        return () => sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open_price]);
    const queryCheckInfo = (0, react_1.useCallback)(() => {
        const request = parseParamsToRequest(requestRef.current);
        return queryAPI(request, orderType).pipe((0, operators_1.tap)((value) => {
            setCheckInfo(value);
        }));
    }, [orderType]);
    const queryCheckInfoWithParam = (0, react_1.useCallback)((r_num, current_price) => {
        const p = Object.assign(Object.assign({}, requestRef.current), { reduce_num: r_num, open_price: current_price });
        requestRef.current = p;
        const request = parseParamsToRequest(requestRef.current);
        return queryAPI(request, orderType).pipe((0, operators_1.tap)((value) => {
            setCheckInfo(value);
        }));
    }, [orderType]);
    return { checkInfo, queryCheckInfo, queryCheckInfoWithParam, loading: loading };
};
exports.useReducePositionCheckInfo = useReducePositionCheckInfo;
